import { render } from "./MarkupDialog.vue?vue&type=template&id=5fa07b3b&scoped=true"
import script from "./MarkupDialog.vue?vue&type=script&lang=js"
export * from "./MarkupDialog.vue?vue&type=script&lang=js"

import "./MarkupDialog.vue?vue&type=style&index=0&id=5fa07b3b&lang=css"
import "./MarkupDialog.vue?vue&type=style&index=1&id=5fa07b3b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa07b3b"]])

export default __exports__